<!-- 流水类型 -->
<template>
  <el-form-item :label="label">
    <yx-basic-selector v-bind="config" v-model="recordType" type="recordType" clearable />
  </el-form-item>
</template>

<script>
import { inject } from 'vue';

export default {
  kind: 'yq-流水类型',
  props: {
    // 初始值.
    value: {
      type: [Array, String, Number],
      default: () => [],
    },
    config: {
      type: Object,
      default() {
        return {};
      },
    },
    label: {
      type: String,
      default: '流水类型：',
    },
  },
  setup(props) {
    const useQuery = inject('useQuery');
    const recordType = useQuery('recordType', props.value);

    return {
      recordType,
    };
  },
};
</script>
